function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#83ABB7;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M124.6,160c-30-5.6-60.5-18.1-80.9-45.8C29.1,94.4,21.5,68.2,21,40.7c-0.2-11.3,0.4-23.4,2.8-34.8 c2.4,6.3,4.8,12.5,7.2,18.8c0.7,1.8,3.5,0.9,2.8-0.9C30.8,16.2,27.9,8.6,25,1c-0.4-1.1-1.6-1.3-2.4-0.6c-3.4,3-6.8,6.1-10.2,9.1 c-2.5,2.2-5,4.3-7.5,6.5c-1,0.7-1.9,1.5-2.9,2.2c-0.3,0.2-0.5,0.4-0.8,0.6C0.9,19,0.8,19,1,19c-1.8,0.5-0.9,3.3,0.9,2.8 c1.5-0.4,3-2.1,4.2-3.1c2.6-2.1,5.1-4.3,7.6-6.5c2.5-2.1,4.9-4.3,7.3-6.5c-2.1,10-2.7,20.6-2.8,30.6c-0.2,26.6,5.8,52.6,18.5,73 c20.5,33,54.1,47.8,87.3,54C125.7,163.6,126.3,160.3,124.6,160z"
});

var SvgSearchArrow = function SvgSearchArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125.6 163.3",
    style: {
      enableBackground: "new 0 0 125.6 163.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearchArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search_arrow.1368d9c9.svg";
export { ForwardRef as ReactComponent };